export const MODAL_GIFT_PERIOD_NOTIFICATION_STATIC_KEY = 'modalGiftPeriodNotification'
export default MODAL_GIFT_PERIOD_NOTIFICATION_STATIC_KEY
